import { getWxJsSdk } from '$services/index'

interface IJweixinOptions {
  url: string;
  debug: boolean;
  jsApiList: string[];
}

export const jweixin = (_options?: IJweixinOptions): Promise<any> => {
  const options = Object.assign({
    url: window.location.href,
    debug: false,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'closeWindow']
  }, _options)

  return getWxJsSdk({
    url: window.location.href
  }).then((result) => {
    window.wx.config({
      debug: options.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: result.appId, // 必填，公众号的唯一标识
      timestamp: result.timeStamp, // 必填，生成签名的时间戳
      nonceStr: result.nonceStr, // 必填，生成签名的随机串
      signature: result.signature, // 必填，签名
      jsApiList: options.jsApiList // 必填，需要使用的JS接口列表
    })

    /* window.wx.ready(() => {
      // 分享到朋友圈
      window.wx.onMenuShareTimeline({
        title: '分享标题', // 分享标题
        link: 'url', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        success() {
          // 用户点击了分享后执行的回调函数
        },
      })
      // 分享给朋友
      window.wx.onMenuShareAppMessage({
        title: '分享标题', // 分享标题
        desc: '分享描述', // 分享描述
        link: 'url', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        success() {
          // 用户点击了分享后执行的回调函数
        },
      })
      // 分享到QQ
      window.wx.onMenuShareQQ({
        title: '分享标题', // 分享标题
        desc: '分享描述', // 分享描述
        link: 'url', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        success() {
          // 用户点击了分享后执行的回调函数
        },
      })
    }) */
  })
}

export default {
  jweixin,
}